"use client"

import { useAppStore } from "@/store"
import { Button } from "@preview-kit/ui/components/button"
import { cn } from "@preview-kit/ui/lib/utils"
import { ArrowLeft } from "lucide-react"
import { QRCode } from "react-qrcode-logo"
import { useShallow } from "zustand/shallow"
import CommandListView from "../command-list"

export default function QrCodeView() {
	const { setNavigation, setAnimateClick } = useAppStore(
		useShallow((state) => ({
			setNavigation: state.setNavigation,
			setAnimateClick: state.setAnimateClick,
		})),
	)

	return (
		<>
			<div className={cn("flex-1 overflow-y-auto p-2", "scroll_area")}>
				<Button
					size="icon"
					className="absolute top-4 left-4 z-50 w-7 h-7 flex items-center justify-center bg-neutral-200"
					variant="outline"
					onClick={() => {
						setAnimateClick()
						setNavigation({
							currentView: <CommandListView />,
							breadcrumb: [],
							viewStack: [],
						})
					}}
				>
					<ArrowLeft />
				</Button>

				<div className="mt-10 space-y-6 mx-7">
					<div className="flex flex-col items-center space-y-6">
						{/* Header */}
						<div className="text-center space-y-2">
							<h1 className="text-xl font-semibold text-gray-900">QR code</h1>
							<p className="text-sm text-gray-600">
								Scan the QR code with your phone to access this deployment.
							</p>
						</div>

						{/* QR Code with Logo */}
						<div className="relative border border-gray-200 rounded-lg p-2">
							<QRCode
								value="https://v0.dev/chat/integrate-image-in-code-egBjxKE8kxh"
								size={200}
								logoImage="https://www.krasamo.com/wp-content/uploads/Screen-Shot-2020-06-30-at-4.13.57-PM.png" // Make sure this path is correct
								logoWidth={30}
								logoHeight={30}
								logoPadding={5}
								qrStyle="squares"
								removeQrCodeBehindLogo={true}
								ecLevel="M"
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
